import React from 'react';
import './PracticeAreaModal.css';

interface PracticeAreaModalProps {
    isOpen: boolean;
    onClose: () => void;
    title: string;
    description: string;
    image: string;
}

const PracticeAreaModal: React.FC<PracticeAreaModalProps> = ({ 
    isOpen, 
    onClose, 
    title, 
    description, 
    image 
}) => {
    if (!isOpen) return null;

    const handleBackdropClick = (e: React.MouseEvent) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    return (
        <div className="modal-backdrop" onClick={handleBackdropClick}>
            <div className="modal-content">
                <button className="modal-close" onClick={onClose}>
                    ✕
                </button>
                <div className="modal-header">
                    <img src={image} alt={title} className="modal-image" />
                    <h2>{title}</h2>
                </div>
                <div className="modal-body">
                    <p> {description.split('\n').map((line, idx) => (
                            <React.Fragment key={idx}>
                            {line}
                            <br />
                            </React.Fragment>
                        ))}
                    </p>
                    <div className="modal-actions">
                        <a href="/client-intake" className="cta-button">
                            Get Legal Help
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PracticeAreaModal;